import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from 'components/shared-components/Loading';
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import PermissionsGate from "components/util-components/Permisos/PermissionsGate";
import { useUserData } from 'components/util-components/Permisos/useUserData';

const AdminVista = lazy(() => import(`./admin`))


export const AppViews = () => {
  const usuarioData = useUserData()

  return (
    <Suspense fallback={<Loading cover="content"/>}>
      <Switch>
      
        <Route path={`${APP_PREFIX_PATH}/components`} component={lazy(() => import(`./components`))} />
        <Route path={`${APP_PREFIX_PATH}/pages`} component={lazy(() => import(`./paginas`))} />
        <Route path={`${APP_PREFIX_PATH}/perfil`} component={lazy(() => import(`./perfil`))} />
        <Route path={`${APP_PREFIX_PATH}/finanzas`} component={lazy(() => import(`./finanzas`))} />
        <Route path={`${APP_PREFIX_PATH}/conceptos`} component={lazy(() => import(`./conceptos`))} />
        <Route path={`${APP_PREFIX_PATH}/facturas`} component={lazy(() => import(`./facturas`))} />
        <Route path={`${APP_PREFIX_PATH}/comprar-folios`} component={lazy(() => import(`./comprar-folios`))} />


        {/* <Route path={`${APP_PREFIX_PATH}/admin`} component={lazy(() => import(`./admin`))} /> */}
        <Route path={`${APP_PREFIX_PATH}/admin`} render={(routeProps) => {
          return (
          <PermissionsGate  tiposUser={["admingeneral","adminsub"]} >
          <AdminVista {...routeProps} />
          </PermissionsGate>
          )}
        }
        />
        {/* <Route path={`${APP_PREFIX_PATH}/admin`}  component={() => {
        return (<PermissionsGate  tiposUser={["admingeneral","adminsub"]} >
        <AdminVista />
        </PermissionsGate>)
        }} /> */}
        {/* ///ALUMNOS */}
        <Route path={`${APP_PREFIX_PATH}/archivos`} component={lazy(() => import(`./archivos`))} />
        <Route path={`${APP_PREFIX_PATH}/none`} component={lazy(() => import(`./none/apps`))} />
        {/* ERROR 404 */}
        <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/facturas/emitidas`} />
      </Switch>
    </Suspense>
  )
}

export default React.memo(AppViews);
